/*!
 *
 *  overlay.ts
 *
 */
class OverlayController {
    el;
    openSet = new Set();
    constructor(el) {
        this.el = el;
        this.apply();
    }
    open(key) {
        this.openSet.add(key);
        this.apply();
    }
    close(key) {
        this.openSet.delete(key);
        this.apply();
    }
    toggle(key, isOpen) {
        if (isOpen)
            this.open(key);
        else
            this.close(key);
    }
    reset() {
        this.openSet.clear();
        this.apply();
    }
    apply() {
        const visible = this.openSet.size > 0;
        this.el.classList.toggle("-visible", visible);
    }
}
export const overlay = new OverlayController(document.getElementById("overlay"));
